import { Trans } from 'react-i18next'

import { formatMoneyV2 } from '~/helpers'

import { useRechargeForm } from '../../../../../hooks/useRechargeForm'

const MarketplaceOptionLabel = () => {
  const { balanceMarketplaceData, errorMarketplaceBalance } = useRechargeForm()

  const balanceFormatted = formatMoneyV2({
    value: balanceMarketplaceData?.total
  })

  return (
    <Trans
      // @ts-expect-error: `i18nKey` is not recognized by the `Trans` component
      i18nKey="rm:marketplace.radio.label"
      values={{ value: balanceFormatted }}
      components={{
        small: (
          <small
            style={{ display: errorMarketplaceBalance ? 'none' : 'inline' }}
          />
        )
      }}
    />
  )
}

export default MarketplaceOptionLabel
